let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4aISv")).then(() => parcelRequire('9vqPP'));